"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_REFERENCE_GRAMMAR_ID = void 0;
exports["default"] = setReferenceGrammarID;
var SET_REFERENCE_GRAMMAR_ID = 'WEB_CHAT/SET_REFERENCE_GRAMMAR_ID';
exports.SET_REFERENCE_GRAMMAR_ID = SET_REFERENCE_GRAMMAR_ID;

function setReferenceGrammarID(referenceGrammarID) {
  return {
    type: SET_REFERENCE_GRAMMAR_ID,
    payload: {
      referenceGrammarID: referenceGrammarID
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfUkVGRVJFTkNFX0dSQU1NQVJfSUQiLCJzZXRSZWZlcmVuY2VHcmFtbWFySUQiLCJyZWZlcmVuY2VHcmFtbWFySUQiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFJlZmVyZW5jZUdyYW1tYXJJRC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfUkVGRVJFTkNFX0dSQU1NQVJfSUQgPSAnV0VCX0NIQVQvU0VUX1JFRkVSRU5DRV9HUkFNTUFSX0lEJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0UmVmZXJlbmNlR3JhbW1hcklEKHJlZmVyZW5jZUdyYW1tYXJJRCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFVF9SRUZFUkVOQ0VfR1JBTU1BUl9JRCxcbiAgICBwYXlsb2FkOiB7IHJlZmVyZW5jZUdyYW1tYXJJRCB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFNFVF9SRUZFUkVOQ0VfR1JBTU1BUl9JRCB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsd0JBQXdCLEdBQUcsbUNBQWpDOzs7QUFFZSxTQUFTQyxxQkFBVCxDQUErQkMsa0JBQS9CLEVBQW1EO0VBQ2hFLE9BQU87SUFDTEMsSUFBSSxFQUFFSCx3QkFERDtJQUVMSSxPQUFPLEVBQUU7TUFBRUYsa0JBQWtCLEVBQWxCQTtJQUFGO0VBRkosQ0FBUDtBQUlEIn0=